export type HeightTypes = typeof heights;

export const heights = {
	header: '8.6rem',
	headerMobile: '6.4rem',
};
